export default __webpack_public_path__ + "static/media/Cloud-wind.784e245c.svg";